import { LwApiPM } from "@techniaorg/liteweb-api";
import { waitForIFrameAndModel } from "../src/util";

// Wait until the iframe is loaded
const myframe = document.querySelector("iframe#webviewer") as HTMLIFrameElement;
let LwAPI: LwApiPM | null = null;
const apiReady: Promise<LwApiPM | null> = waitForIFrameAndModel(myframe)
  .then((api) => {
    LwAPI = api;
    return api;
  })
  .catch((e) => {
    console.log("LwAPI could not be initialized: ", e);
    return null;
  });

var FoundNodes: any[] = [];
var n = 0;

function ex_setnodeselection(str: string) {
  LwAPI?.getTree().then(function (tree) {
    FoundNodes = [];
    if (Array.isArray(tree)) {
      FindNodeRec(tree[0].root.children, "text", str);
    } else FindNodeRec(tree.root.children, "text", str);
    if (FoundNodes.length == 0) {
      alert("Nothing found");
    } else {
      LwAPI?.setNodeSelection(FoundNodes[0], true);
    }
  });
}

function FindNodeRec(obj: any, key: any, val: any) {
  // obj should be initially tree.root.children, on recursion tree.root.children[i].children

  for (var i = 0; i < obj.length; i++) {
    if (obj[i][key].toLowerCase().indexOf(val.toLowerCase()) > -1) {
      // @ts-ignore
      FoundNodes.push(obj[i].id);
    }
    if (typeof obj[i].children == "object") {
      var childObj = obj[i].children;
      FindNodeRec(childObj, key, val);
    }
  }
}

function ex_selectPrev() {
  if (n > 0) {
    LwAPI?.setNodeSelection(FoundNodes[n - 1], true);
    n = n - 1;
  } else {
    alert("No previous match.");
  }
}

function ex_selectNext() {
  if (n < FoundNodes.length - 1) {
    LwAPI?.setNodeSelection(FoundNodes[n + 1], true);
    n = n + 1;
  } else {
    alert("No further match.");
  }
}

document.getElementById("selectFirstMatch")?.addEventListener("click", async () => {
  await apiReady;
  const findStr = (document.getElementById("findstr") as HTMLInputElement)
    .value;
  ex_setnodeselection(findStr);
});

document.getElementById("selectPrev")?.addEventListener("click", async () => {
  await apiReady;
  ex_selectPrev();
});

document.getElementById("selectNext")?.addEventListener("click", async () => {
  await apiReady;
  ex_selectNext();
});
